import PropTypes from 'prop-types';

import { useAuth } from '../hooks';

const FeatureFilter = ({ children, feature, fallback = null }) => {
  const { hasFeature } = useAuth();

  return hasFeature(feature) ? children : fallback;
};

FeatureFilter.propTypes = {
  feature: PropTypes.string.isRequired,
  fallback: PropTypes.element
};

export default FeatureFilter;
